import { get } from 'lodash';
import React, { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import useT from '../../utils/Translations/useT';
import { RETURN_TYPE } from '../base/SelectBox';
import SelectBoxFilter from './SelectBoxFilter';
import getGqlOperationName from '../../../utils/getGqlOperationName';
import Error from '../../utils/Error';
import Statuses from '../../../../model/StatusWithDraft';
import eContentLibraryResourcesGql from '../../../data/eContent/eContentLibraryResources.graphql';
const EContentLibraryResourcesSingleSelector = ({ value, onChange, libraryId, ...rest }) => {
    const t = useT();
    const { loading, error, data } = useQuery(eContentLibraryResourcesGql, {
        variables: { libraryId, status: Statuses.BasicProps },
        skip: !libraryId,
    });
    const resources = useMemo(() => get(data, getGqlOperationName(eContentLibraryResourcesGql), []), [data]);
    const isDisabled = useMemo(() => !libraryId || loading, [libraryId, loading]);
    if (error) {
        return <Error error={error}/>;
    }
    return (<SelectBoxFilter disabled={isDisabled} itemTitlePropName="name" itemValuePropName="id" loading={loading} options={resources} returnType={RETURN_TYPE.NUMBER} title={t('Resource')} value={value} onChange={onChange} {...rest}/>);
};
export default EContentLibraryResourcesSingleSelector;
